import React from 'react'

import { useSlotSession } from 'modules/SlotsRoot/hooks/useSlotSession'

import RouteReplacingSlots from '../RouteReplacingSlots'

const SlotRedirect: React.FC = () => {
  const { isLoading, isGameListLoading } = useSlotSession()

  return !isGameListLoading && isLoading ? (
    <RouteReplacingSlots />
  ) : (
    <>
      {/* <Spinner isLoading /> */}
      Loading...
    </>
  )
}

export default SlotRedirect
